<div class="d-flex align-items-center justify-content-center px-2 py-2 content-container">
    {{ 'GENERAL.WAIT_WHILE_LOADING_DONT_CLOSE_PAGE' | translate }}
</div>
